import Vue from 'vue';
import Vuex from 'vuex';
import pages from './modules/pages';
import home from './modules/home';
import news from './modules/news';
import user from './modules/user';
import userEvent from './modules/userEvent';
import admin from './modules/admin';
import images from './modules/images';
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    error: {}
  },
  mutations: {
    setError(state, error) {
      state.error = error;
    }
  },
  modules: {
    pages,
    home,
    news,
    images,
    user,
    userEvent,
    admin
  },
  strict: process.env.NODE_ENV !== 'production',
  plugins: [
    createPersistedState({ storage: window.sessionStorage ? window.sessionStorage : window.localStorage })
  ]
});
